import React from 'react';
import { Link } from 'react-router-dom';

export const Button = ({ col, to, icon, label }) => (
    <div className={col}>
        <Link to={to} type="button" className="btn btn-custom-theme btn-block">
            <i className={icon}></i> {label}
        </Link>
    </div>
);


// WEBPACK FOOTER //
// ./Public/src/js/component/home/children/button.jsx